import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatIdleCountdown } from '../../utils/idleSessionUtils';

const { Title, Text } = Typography;

const IdleSessionPrompt = ({ warningOpen, secondsRemaining, staySignedIn }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={warningOpen}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={360}
    >
      <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
        <Title level={4} style={{ marginBottom: 8 }}>
          {t('session.idle.title', 'Are you still here?')}
        </Title>
        <Text type="secondary">
          {t('session.idle.message', 'You will be signed out due to inactivity in')}
        </Text>
        <div style={{ fontSize: 48, fontWeight: 600, lineHeight: 1.2, margin: '16px 0 24px' }}>
          {formatIdleCountdown(secondsRemaining)}
        </div>
        <Button type="primary" size="large" block onClick={staySignedIn}>
          {t('session.idle.staySignedIn', 'Stay signed in')}
        </Button>
      </div>
    </Modal>
  );
};

export default IdleSessionPrompt;
